import { IStyle, ITheme } from "@fluentui/react";

interface ISinglePageAppStyles {
    root: IStyle[];
    main: IStyle[];
    contentArea: IStyle[];
}

export const getSinglePageAppStyles = (): ISinglePageAppStyles => {
    return {
        root: [
            {
                display: 'flex',
                flexDirection: 'column',
                height: '100%'
            }
        ],
        main: [
            {
                display: 'flex',
                flexDirection: 'row',
                flexGrow: 1,
                alignItems: 'stretch'
            }
        ],
        contentArea: [
            {
                width: 1,
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            }
        ],
    };
}; 

interface ISubsectionedPageStyles {
    root: IStyle[];
    contentArea: IStyle[];
}

export const getSubsectionedPageStyles = (): ISubsectionedPageStyles => {
    return {
        root: [
            {
                display: 'flex',
                flexDirection: 'row',
                flexGrow: 1,
            },
        ],
        contentArea: [
            {
                flexGrow: 1,
                display: 'flex',
            },
        ],
    };
}; 

interface IContentSectionStyles {
    root: IStyle[];
    content: IStyle[];
}

export const getContentSectionStyles = (theme: ITheme): IContentSectionStyles => {
    return {
        root: [
            {
                flexGrow: 1,
                backgroundColor: theme.palette.neutralLighterAlt
            }
        ],
        content: [
            {
                padding: 20,
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
            }
        ],
    };
};
